@if (item.template !== 'loadMore') {
  <div class="search-result__title" [matTooltip]="getSearchDisplayName(item)?.length > 100 ? getSearchDisplayName(item) : ''">
    <h2>{{getSearchDisplayName(item)}}</h2>
    @if (item.template !== 'heading') {
      <button matIconButton
        (click)="onClick_collapse()"
        [attr.aria-expanded]="!collapsed"
        [attr.aria-label]="'View details for \''+item.title+'\''">
        @if (collapsed) {
          <mat-icon>expand_more</mat-icon>
        }
        @if (!collapsed) {
          <mat-icon>expand_less</mat-icon>
        }
      </button>
    }
  </div>
  <div class="subgrid search-result__wrapper" [@detailExpand]="collapsed ? 'collapsed' : 'expanded'">
    <div class="subgrid search-result__detail-wrapper">
      @if (standardDetails?.length > 0) {
        <dl class="subgrid" [attr.aria-label]="item.title + ' details'">
          @for (detail of standardDetails; track detail) {
            @if (detail.type === ItemDetailTypeEnum.Default) {
              <div class="subgrid search-result__detail">
                <dt>{{ detail.description }}</dt>
                <dd>{{ detail.value }}</dd>
              </div>
            }
          }
        </dl>
      }
      @if (actionableDetails?.length > 0) {
        <div class="search-result__actions" [attr.aria-label]="item.title + ' actions'">
          @for (detail of actionableDetails; track detail) {
            @if (detail.type === ItemDetailTypeEnum.Download && detail.billUrl) {
              <a matButton
                [attr.aria-label]="'View ' + detail.description"
                [href]="detail.billUrl"
                target="_blank">
                @if (!detail.downloading) {
                  <mat-icon>open_in_new</mat-icon>
                }
                @if (detail.downloading) {
                  <mat-spinner diameter="24"></mat-spinner>
                }
                <span>{{ detail.description.replace("_download_", '') }}</span>
              </a>
            }
            @if (detail.type === ItemDetailTypeEnum.Download && !detail.billUrl) {
              <button matButton
                [attr.aria-label]="'View ' + detail.description"
                (click)="viewFileError()">
                @if (!detail.downloading) {
                  <mat-icon>open_in_new</mat-icon>
                }
                @if (detail.downloading) {
                  <mat-spinner diameter="24"></mat-spinner>
                }
                <span>{{ detail.description.replace("_download_", '') }}</span>
              </button>
            }
            @if (detail.type === ItemDetailTypeEnum.Popup) {
              <button
                aria-haspopup="dialog"
                matButton
                (click)="onClick_popup(detail.value, $event)">
                @let popupSvg = getPopupSvg(detail.value);
                @if (popupSvg) {
                  <!-- TODO (top-3024): dynamic popup icon (getPopupSvg) — data-driven, needs decision -->
                  <!-- The icon SVGs paint with currentColor, so a status icon takes its tone here -->
                  <mat-icon
                    [svgIcon]="popupSvg"
                    [class.teller-online-icon--danger]="popupSvg === 'error'
                      || popupSvg === 'cancel' || popupSvg === 'close'"
                    [class.teller-online-icon--success]="popupSvg === 'success'
                      || popupSvg === 'payment-complete'"></mat-icon>
                }
                <span>{{ detail.description.replace("_popup_", '') }}</span>
              </button>
            }
            @if (detail.type === ItemDetailTypeEnum.Link) {
              <a
                class="detail-link link"
                [href]="detail.value"
                target="_blank">
                <mat-icon>link</mat-icon>
                {{ detail.description.replace("_link_", '') }}
              </a>
            }
          }
        </div>
      }
      @if (item.template !== 'heading' && itemIsPayable) {
        @if (item.amountInCart && (item.selectedPaymentOption || item.selectedPaymentOptions?.length)) {
          <div class="subgrid change-payment-option" [ngClass]="{'change-payment-option--invalid': !itemHasSinglePaymentOptionSelected}">
            <span class="change-payment-option__name">
              Payment Total {{itemHasSinglePaymentOptionSelected ? '(' + item.selectedPaymentOption?.label + ')' : ''}}
            </span>
            <div class="change-payment-option__section">
              @if (itemHasSinglePaymentOptionSelected) {
                <span class="change-payment-option__amount">{{item.selectedPaymentOption.amount | currency: "USD"}}</span>
              }
              @if (item.selectedPaymentOptions?.length > 1 && checkItemAmountIsEditable(item)) {
                <button type="button" matButton="filled" class="change-payment-option__choose"
                  cdkOverlayOrigin #chooseOrigin="cdkOverlayOrigin"
                  [attr.aria-haspopup]="checkPaymentOptionNeedsPrompt(item?.paymentOptions) ? 'dialog' : null"
                  [attr.aria-expanded]="checkPaymentOptionNeedsPrompt(item?.paymentOptions) ? selectPaymentPanelOpen : null"
                  [attr.aria-controls]="selectPaymentPanelOpen ? selectPaymentPanelId : null"
                  (click)="onClick_addToCartOrSelectPayment(item, chooseOrigin)">
                  <mat-icon>payments</mat-icon>
                  <span>Choose Payment Option</span>
                </button>
              }
              @if (itemHasSinglePaymentOptionSelected && checkPaymentOptionNeedsPrompt(item.paymentOptions) && checkItemAmountIsEditable(item)) {
                <button type="button" matButton class="change-payment-option__change"
                  cdkOverlayOrigin #editOrigin="cdkOverlayOrigin"
                  [attr.aria-haspopup]="checkPaymentOptionNeedsPrompt(item?.paymentOptions) ? 'dialog' : null"
                  [attr.aria-expanded]="checkPaymentOptionNeedsPrompt(item?.paymentOptions) ? selectPaymentPanelOpen : null"
                  [attr.aria-controls]="selectPaymentPanelOpen ? selectPaymentPanelId : null"
                  (click)="onClick_addToCartOrSelectPayment(item, editOrigin)">
                  <mat-icon>edit</mat-icon>
                  <span>Edit</span>
                </button>
              }
            </div>
          </div>
        }
        <div class="search-result__actions">
          @if (item.amountInCart && !inboundRedirectService.isInboundRedirectUIContext) {
            <button matButton="tonal"
              type="button"
              class="search-result__remove-btn"
              (click)="onClick_removeFromCart(item)"
              aria-controls="aria_cart">
              <mat-icon>remove_shopping_cart</mat-icon>
              <span>Remove From Cart</span>
            </button>
          }
          @if (!item.amountInCart) {
            <!-- disabledInteractive keeps the button hoverable and focusable so the
            paymentDisabledMessage tooltip saying why can be reached (O69b). Other disabled cases
            have no message, so they stay natively disabled rather than focusable but silent. -->
            <button matButton="filled"
              cdkOverlayOrigin #addToCartOrigin="cdkOverlayOrigin"
              [attr.aria-haspopup]="checkPaymentOptionNeedsPrompt(item?.paymentOptions) ? 'dialog' : null"
              [attr.aria-expanded]="checkPaymentOptionNeedsPrompt(item?.paymentOptions) ? selectPaymentPanelOpen : null"
              type="button"
              class="search-result__add-btn"
              [disabled]="addToCartDisabled"
              [disabledInteractive]="paymentDisabled"
              [matTooltip]="paymentDisabled ? paymentDisabledMessage : ''"
              matTooltipPosition="after"
              data-guide="add-to-cart"
              (click)="onClick_addToCart(item, addToCartOrigin)"
              [attr.aria-controls]="selectPaymentPanelOpen ? selectPaymentPanelId : 'aria_cart'">
              <mat-icon>add_shopping_cart</mat-icon>
              <span>Add to Cart</span>
            </button>
          }
          @if (itemIsSchedulable) {
            <!-- disabledInteractive keeps the unavailable button hoverable and focusable, so the
            tooltip saying why can be reached by mouse, keyboard and screen reader (O69). -->
            <button matButton
              type="button"
              class="search-result__add-btn"
              [disabled]="!itemCanSchedule"
              disabledInteractive
              [matTooltip]="itemCanSchedule ? '' : scheduleUnavailableMessage"
              matTooltipPosition="after"
              (click)="onClick_schedule()">
              <mat-icon>schedule</mat-icon>
              <span>Schedule</span>
            </button>
          }
        </div>
        <!-- Payment options panel (wide viewports; narrow uses a bottom sheet). A role="dialog"
        rather than a mat-menu: a custom-amount option renders a form inside this panel, and a form
        is not a permitted child of role="menu" (A11Y-029). The option list itself is unchanged.
        The origin is whichever of the three triggers above was used — their @if conditions are
        mutually exclusive, so only one exists at a time. -->
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="selectPaymentOrigin"
          [cdkConnectedOverlayOpen]="selectPaymentPanelAttached && !!selectPaymentOrigin"
          [cdkConnectedOverlayPositions]="selectPaymentPanelPositions"
          [cdkConnectedOverlayPush]="true"
          [cdkConnectedOverlayViewportMargin]="overlayViewportMargin"
          [cdkConnectedOverlayHasBackdrop]="true"
          cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
          (backdropClick)="closeSelectPayment()"
          (overlayKeydown)="onKeydown_selectPayment($event)">
          <div class="select-payment-panel"
            [id]="selectPaymentPanelId"
            [class.select-payment-panel--exiting]="selectPaymentPanelExiting"
            (animationend)="onAnimationEnd_selectPaymentPanel()"
            (animationcancel)="onAnimationEnd_selectPaymentPanel()"
            role="dialog"
            tabindex="-1"
            aria-modal="false"
            [attr.aria-label]="'Choose payment option for ' + item.title"
            cdkTrapFocus
            [cdkTrapFocusAutoCapture]="true">
            <app-select-payment
              [item]="item"
              (closePopup)="closeSelectPayment()"
              [conflictingOptions]="selectPaymentConflictingOptions"
              (addToCart)="on_addToCart($event)"
              (updateCartItem)="on_updateCartItem($event)">
            </app-select-payment>
          </div>
        </ng-template>
      }
    </div>
  </div>
}

@if (item.template === 'loadMore') {
  <button matButton="filled" type="button" (click)="onClick_loadMore()">
    Show More Results
  </button>
}
